import { createFileRoute, Navigate } from '@tanstack/react-router';
import { getMarketingLandingPath } from '@/features/marketing/nav/marketing-nav-items';
import { useMarketingAccess } from '@/features/marketing/use-marketing-access';

export const Route = createFileRoute('/_auth/$orgId/marketing/')({ component: MarketingIndex });

/**
 * `/marketing` lands on the first nav item this user can see (admins → Bio Page). The layout only
 * mounts this after access resolves; `null` means nothing is visible, so render nothing.
 */
function MarketingIndex() {
  const { orgId } = Route.useParams();
  const to = getMarketingLandingPath(useMarketingAccess());
  return to ? <Navigate to={to} params={{ orgId }} replace /> : null;
}
